import {useEffect, useState} from "react";

export const useIP = () => {
  const [ip, setIP] = useState("");

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then(res => res.json())
      .then(res => {
        setIP(res.ip);
      });
  }, []);

  return {ip};
};
